import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "emptyState",
    "typeSelect",
    "linkTextField",
    "urlField",
    "pageSelect"
  ]

  showForm() {
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add("hidden")
    }
    this.formTarget.classList.remove("hidden")
  }

  hideForm() {
    this.formTarget.classList.add("hidden")
    this.clearForm()

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.remove("hidden")
    }
  }

  clearForm() {
    this.typeSelectTarget.querySelector("select").value = ""

    this.linkTextFieldTarget.classList.add("hidden")
    this.linkTextFieldTarget.querySelector("input[type=text]").value = ""

    this.urlFieldTarget.classList.add("hidden")
    this.urlFieldTarget.querySelector("input[type=text]").value = ""

    this.pageSelectTarget.classList.add("hidden")
    this.pageSelectTarget.querySelector("select").selectedIndex = 0
  }

  typeChanged(event) {
    const type = event.target.value

    this.typeSelectTarget.classList.remove("hidden")
    this.linkTextFieldTarget.classList.remove("hidden")

    if (type === "Content::Menu::ExternalLinkItem") {
      this.pageSelectTarget.classList.add("hidden")
      this.pageSelectTarget.value = ""

      this.urlFieldTarget.classList.remove("hidden")
    } else if (type === "Content::Menu::PageLinkItem") {
      this.urlFieldTarget.classList.add("hidden")
      this.urlFieldTarget.value = ""

      this.pageSelectTarget.classList.remove("hidden")
    }
  }
}
